import { Reveal } from "./Reveal";

const TRAPS = [
  {
    label: "Way one",
    title: "Strung along, then cut loose",
    body: "A carrier that benefits from delay keeps you waiting on an adjuster — while the water spreads. By the time attention arrives, the easy fix has become an expensive one, and the responsibility quietly shifts back toward you.",
  },
  {
    label: "Way two",
    title: "Blamed for failure-to-mitigate",
    body: "Later, you can be held responsible for mold and structural costs that prompt, documented action would have prevented. Waiting doesn't protect you here — it exposes you.",
  },
];

export const WaitingTrap = () => {
  return (
    <section data-testid="waiting-trap-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:sticky lg:top-28">
            <span className="font-mono text-[12px] tracking-[0.22em] uppercase text-erg-mid">
              The honest part
            </span>
            <h2 className="mt-4 font-display font-bold uppercase text-erg-ink leading-[0.95] text-[clamp(2rem,6vw,3.75rem)]">
              Why waiting<br />is the trap
            </h2>
            <p className="mt-6 text-erg-ink/75 text-lg leading-relaxed max-w-md text-pretty">
              Water doesn't wait for an adjuster. Within 24–48 hours it migrates into
              drywall, subfloor, and framing, and mold can begin. Homeowners who wait
              tend to get burned one of two ways.
            </p>
          </Reveal>

          <div className="space-y-6">
            {TRAPS.map((t, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <article className="rounded-2xl border border-erg-ink/10 bg-white/60 p-7 sm:p-8">
                  <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-erg-mid">
                    {t.label}
                  </span>
                  <h3 className="mt-2 font-display font-semibold text-erg-ink text-2xl sm:text-[1.75rem] leading-tight">
                    {t.title}
                  </h3>
                  <p className="mt-3 text-erg-ink/75 text-base sm:text-lg leading-relaxed">
                    {t.body}
                  </p>
                </article>
              </Reveal>
            ))}
            <Reveal delay={0.15}>
              <p className="rounded-2xl bg-erg-ink p-7 sm:p-8 text-erg-dry text-lg sm:text-xl leading-relaxed font-medium text-pretty">
                Acting now, with documented mitigation, is what actually protects both
                your home <span className="text-erg-aqua">and</span> your claim.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
